/* eslint-disable prefer-arrow/prefer-arrow-functions */

import { Nullable } from 'constants/types'

/**
 * TabIndex Utility methods
 */
export const TabIndexUtils = {
    /**
     * set tab index of an element to value
     * @param el
     * @param value
     */
    setTabIndex(el: Element, value: string | number): void {
        if (!el) {
            return
        }
        el.setAttribute('tabindex', value as string)
    },

    /**
     * sets tab index to -1 to hide from default tabbing
     * @param el
     */
    hideTabIndex(el: Nullable<Element>): void {
        if (!el) {
            return
        }
        this.setTabIndex(el, '-1')
    },

    /**
     * remove tab index from an element
     * @param el
     */
    removeTabIndex(el: Nullable<Element>): void {
        if (!el) {
            return
        }
        el.removeAttribute('tabindex')
    }
}
